"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgUpdatePoolResponse = exports.UpdatePoolParams = exports.MsgUpdatePool = exports.MsgSetCommitmentCurveResponse = exports.SetCommitmentCurveParams = exports.MsgSetCommitmentCurve = exports.MsgSetRewardCurveResponse = exports.SetRewardCurveParams = exports.MsgSetRewardCurve = exports.MsgClaimPoolRewardsResponse = exports.MsgClaimPoolRewards = exports.MsgUnstakePoolTokenResponse = exports.MsgUnstakePoolToken = exports.MsgStakePoolTokenResponse = exports.MsgStakePoolToken = exports.MsgSetRewardsWeightsResponse = exports.SetRewardsWeightsParams = exports.MsgSetRewardsWeights = exports.MsgUnlinkPoolResponse = exports.UnlinkPoolParams = exports.MsgUnlinkPool = exports.MsgLinkPoolResponse = exports.LinkPoolParams = exports.MsgLinkPool = exports.MsgRemoveLiquidityResponse = exports.MsgRemoveLiquidity = exports.MsgAddLiquidityResponse = exports.MsgAddLiquidity = exports.MsgCreatePoolWithLiquidityResponse = exports.MsgCreatePoolWithLiquidity = exports.MsgCreatePoolResponse = exports.MsgCreatePool = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const timestamp_1 = require("../google/protobuf/timestamp");
const reward_1 = require("../liquiditypool/reward");
exports.protobufPackage = "Switcheo.carbon.liquiditypool";
const baseMsgCreatePool = {
    creator: "",
    tokenADenom: "",
    tokenBDenom: "",
    tokenAWeight: "",
    tokenBWeight: "",
    swapFee: "",
    numQuotes: long_1.default.ZERO,
};
exports.MsgCreatePool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.tokenADenom !== "") {
            writer.uint32(18).string(message.tokenADenom);
        }
        if (message.tokenBDenom !== "") {
            writer.uint32(26).string(message.tokenBDenom);
        }
        if (message.tokenAWeight !== "") {
            writer.uint32(34).string(message.tokenAWeight);
        }
        if (message.tokenBWeight !== "") {
            writer.uint32(42).string(message.tokenBWeight);
        }
        if (message.swapFee !== "") {
            writer.uint32(50).string(message.swapFee);
        }
        if (!message.numQuotes.isZero()) {
            writer.uint32(56).int64(message.numQuotes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreatePool);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.tokenADenom = reader.string();
                    break;
                case 3:
                    message.tokenBDenom = reader.string();
                    break;
                case 4:
                    message.tokenAWeight = reader.string();
                    break;
                case 5:
                    message.tokenBWeight = reader.string();
                    break;
                case 6:
                    message.swapFee = reader.string();
                    break;
                case 7:
                    message.numQuotes = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreatePool);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.tokenADenom =
            object.tokenADenom !== undefined && object.tokenADenom !== null
                ? String(object.tokenADenom)
                : "";
        message.tokenBDenom =
            object.tokenBDenom !== undefined && object.tokenBDenom !== null
                ? String(object.tokenBDenom)
                : "";
        message.tokenAWeight =
            object.tokenAWeight !== undefined && object.tokenAWeight !== null
                ? String(object.tokenAWeight)
                : "";
        message.tokenBWeight =
            object.tokenBWeight !== undefined && object.tokenBWeight !== null
                ? String(object.tokenBWeight)
                : "";
        message.swapFee =
            object.swapFee !== undefined && object.swapFee !== null
                ? String(object.swapFee)
                : "";
        message.numQuotes =
            object.numQuotes !== undefined && object.numQuotes !== null
                ? long_1.default.fromString(object.numQuotes)
                : long_1.default.ZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.tokenADenom !== undefined &&
            (obj.tokenADenom = message.tokenADenom);
        message.tokenBDenom !== undefined &&
            (obj.tokenBDenom = message.tokenBDenom);
        message.tokenAWeight !== undefined &&
            (obj.tokenAWeight = message.tokenAWeight);
        message.tokenBWeight !== undefined &&
            (obj.tokenBWeight = message.tokenBWeight);
        message.swapFee !== undefined && (obj.swapFee = message.swapFee);
        message.numQuotes !== undefined &&
            (obj.numQuotes = (message.numQuotes || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, baseMsgCreatePool);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.tokenADenom = (_b = object.tokenADenom) !== null && _b !== void 0 ? _b : "";
        message.tokenBDenom = (_c = object.tokenBDenom) !== null && _c !== void 0 ? _c : "";
        message.tokenAWeight = (_d = object.tokenAWeight) !== null && _d !== void 0 ? _d : "";
        message.tokenBWeight = (_e = object.tokenBWeight) !== null && _e !== void 0 ? _e : "";
        message.swapFee = (_f = object.swapFee) !== null && _f !== void 0 ? _f : "";
        message.numQuotes =
            object.numQuotes !== undefined && object.numQuotes !== null
                ? long_1.default.fromValue(object.numQuotes)
                : long_1.default.ZERO;
        return message;
    },
};
const baseMsgCreatePoolResponse = { poolId: long_1.default.UZERO };
exports.MsgCreatePoolResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreatePoolResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreatePoolResponse);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseMsgCreatePoolResponse);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        return message;
    },
};
const baseMsgCreatePoolWithLiquidity = {
    creator: "",
    tokenADenom: "",
    tokenBDenom: "",
    tokenAWeight: "",
    tokenBWeight: "",
    amountA: "",
    amountB: "",
    swapFee: "",
    numQuotes: long_1.default.ZERO,
};
exports.MsgCreatePoolWithLiquidity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.tokenADenom !== "") {
            writer.uint32(18).string(message.tokenADenom);
        }
        if (message.tokenBDenom !== "") {
            writer.uint32(26).string(message.tokenBDenom);
        }
        if (message.tokenAWeight !== "") {
            writer.uint32(34).string(message.tokenAWeight);
        }
        if (message.tokenBWeight !== "") {
            writer.uint32(42).string(message.tokenBWeight);
        }
        if (message.amountA !== "") {
            writer.uint32(50).string(message.amountA);
        }
        if (message.amountB !== "") {
            writer.uint32(58).string(message.amountB);
        }
        if (message.swapFee !== "") {
            writer.uint32(66).string(message.swapFee);
        }
        if (!message.numQuotes.isZero()) {
            writer.uint32(72).int64(message.numQuotes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreatePoolWithLiquidity);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.tokenADenom = reader.string();
                    break;
                case 3:
                    message.tokenBDenom = reader.string();
                    break;
                case 4:
                    message.tokenAWeight = reader.string();
                    break;
                case 5:
                    message.tokenBWeight = reader.string();
                    break;
                case 6:
                    message.amountA = reader.string();
                    break;
                case 7:
                    message.amountB = reader.string();
                    break;
                case 8:
                    message.swapFee = reader.string();
                    break;
                case 9:
                    message.numQuotes = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreatePoolWithLiquidity);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.tokenADenom =
            object.tokenADenom !== undefined && object.tokenADenom !== null
                ? String(object.tokenADenom)
                : "";
        message.tokenBDenom =
            object.tokenBDenom !== undefined && object.tokenBDenom !== null
                ? String(object.tokenBDenom)
                : "";
        message.tokenAWeight =
            object.tokenAWeight !== undefined && object.tokenAWeight !== null
                ? String(object.tokenAWeight)
                : "";
        message.tokenBWeight =
            object.tokenBWeight !== undefined && object.tokenBWeight !== null
                ? String(object.tokenBWeight)
                : "";
        message.amountA =
            object.amountA !== undefined && object.amountA !== null
                ? String(object.amountA)
                : "";
        message.amountB =
            object.amountB !== undefined && object.amountB !== null
                ? String(object.amountB)
                : "";
        message.swapFee =
            object.swapFee !== undefined && object.swapFee !== null
                ? String(object.swapFee)
                : "";
        message.numQuotes =
            object.numQuotes !== undefined && object.numQuotes !== null
                ? long_1.default.fromString(object.numQuotes)
                : long_1.default.ZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.tokenADenom !== undefined &&
            (obj.tokenADenom = message.tokenADenom);
        message.tokenBDenom !== undefined &&
            (obj.tokenBDenom = message.tokenBDenom);
        message.tokenAWeight !== undefined &&
            (obj.tokenAWeight = message.tokenAWeight);
        message.tokenBWeight !== undefined &&
            (obj.tokenBWeight = message.tokenBWeight);
        message.amountA !== undefined && (obj.amountA = message.amountA);
        message.amountB !== undefined && (obj.amountB = message.amountB);
        message.swapFee !== undefined && (obj.swapFee = message.swapFee);
        message.numQuotes !== undefined &&
            (obj.numQuotes = (message.numQuotes || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = Object.assign({}, baseMsgCreatePoolWithLiquidity);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.tokenADenom = (_b = object.tokenADenom) !== null && _b !== void 0 ? _b : "";
        message.tokenBDenom = (_c = object.tokenBDenom) !== null && _c !== void 0 ? _c : "";
        message.tokenAWeight = (_d = object.tokenAWeight) !== null && _d !== void 0 ? _d : "";
        message.tokenBWeight = (_e = object.tokenBWeight) !== null && _e !== void 0 ? _e : "";
        message.amountA = (_f = object.amountA) !== null && _f !== void 0 ? _f : "";
        message.amountB = (_g = object.amountB) !== null && _g !== void 0 ? _g : "";
        message.swapFee = (_h = object.swapFee) !== null && _h !== void 0 ? _h : "";
        message.numQuotes =
            object.numQuotes !== undefined && object.numQuotes !== null
                ? long_1.default.fromValue(object.numQuotes)
                : long_1.default.ZERO;
        return message;
    },
};
const baseMsgCreatePoolWithLiquidityResponse = {};
exports.MsgCreatePoolWithLiquidityResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreatePoolWithLiquidityResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgCreatePoolWithLiquidityResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgCreatePoolWithLiquidityResponse);
        return message;
    },
};
const baseMsgAddLiquidity = {
    creator: "",
    poolId: long_1.default.UZERO,
    amountA: "",
    amountB: "",
    minShares: "",
};
exports.MsgAddLiquidity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.poolId.isZero()) {
            writer.uint32(16).uint64(message.poolId);
        }
        if (message.amountA !== "") {
            writer.uint32(26).string(message.amountA);
        }
        if (message.amountB !== "") {
            writer.uint32(34).string(message.amountB);
        }
        if (message.minShares !== "") {
            writer.uint32(42).string(message.minShares);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddLiquidity);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.poolId = reader.uint64();
                    break;
                case 3:
                    message.amountA = reader.string();
                    break;
                case 4:
                    message.amountB = reader.string();
                    break;
                case 5:
                    message.minShares = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAddLiquidity);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.amountA =
            object.amountA !== undefined && object.amountA !== null
                ? String(object.amountA)
                : "";
        message.amountB =
            object.amountB !== undefined && object.amountB !== null
                ? String(object.amountB)
                : "";
        message.minShares =
            object.minShares !== undefined && object.minShares !== null
                ? String(object.minShares)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.amountA !== undefined && (obj.amountA = message.amountA);
        message.amountB !== undefined && (obj.amountB = message.amountB);
        message.minShares !== undefined && (obj.minShares = message.minShares);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseMsgAddLiquidity);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.amountA = (_b = object.amountA) !== null && _b !== void 0 ? _b : "";
        message.amountB = (_c = object.amountB) !== null && _c !== void 0 ? _c : "";
        message.minShares = (_d = object.minShares) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
const baseMsgAddLiquidityResponse = {};
exports.MsgAddLiquidityResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddLiquidityResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgAddLiquidityResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgAddLiquidityResponse);
        return message;
    },
};
const baseMsgRemoveLiquidity = {
    creator: "",
    poolId: long_1.default.UZERO,
    shares: "",
};
exports.MsgRemoveLiquidity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.poolId.isZero()) {
            writer.uint32(16).uint64(message.poolId);
        }
        if (message.shares !== "") {
            writer.uint32(26).string(message.shares);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveLiquidity);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.poolId = reader.uint64();
                    break;
                case 3:
                    message.shares = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveLiquidity);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.shares =
            object.shares !== undefined && object.shares !== null
                ? String(object.shares)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.shares !== undefined && (obj.shares = message.shares);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgRemoveLiquidity);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.shares = (_b = object.shares) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgRemoveLiquidityResponse = {};
exports.MsgRemoveLiquidityResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveLiquidityResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRemoveLiquidityResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRemoveLiquidityResponse);
        return message;
    },
};
const baseMsgLinkPool = { creator: "" };
exports.MsgLinkPool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.linkPoolParams !== undefined) {
            exports.LinkPoolParams.encode(message.linkPoolParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLinkPool);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.linkPoolParams = exports.LinkPoolParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgLinkPool);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.linkPoolParams =
            object.linkPoolParams !== undefined && object.linkPoolParams !== null
                ? exports.LinkPoolParams.fromJSON(object.linkPoolParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.linkPoolParams !== undefined &&
            (obj.linkPoolParams = message.linkPoolParams
                ? exports.LinkPoolParams.toJSON(message.linkPoolParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgLinkPool);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.linkPoolParams =
            object.linkPoolParams !== undefined && object.linkPoolParams !== null
                ? exports.LinkPoolParams.fromPartial(object.linkPoolParams)
                : undefined;
        return message;
    },
};
const baseLinkPoolParams = { poolId: long_1.default.UZERO, market: "" };
exports.LinkPoolParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.market !== "") {
            writer.uint32(18).string(message.market);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseLinkPoolParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.market = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseLinkPoolParams);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.market =
            object.market !== undefined && object.market !== null
                ? String(object.market)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.market !== undefined && (obj.market = message.market);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseLinkPoolParams);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.market = (_a = object.market) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseMsgLinkPoolResponse = {};
exports.MsgLinkPoolResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLinkPoolResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgLinkPoolResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgLinkPoolResponse);
        return message;
    },
};
const baseMsgUnlinkPool = { creator: "" };
exports.MsgUnlinkPool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.unlinkPoolParams !== undefined) {
            exports.UnlinkPoolParams.encode(message.unlinkPoolParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUnlinkPool);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.unlinkPoolParams = exports.UnlinkPoolParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUnlinkPool);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.unlinkPoolParams =
            object.unlinkPoolParams !== undefined && object.unlinkPoolParams !== null
                ? exports.UnlinkPoolParams.fromJSON(object.unlinkPoolParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.unlinkPoolParams !== undefined &&
            (obj.unlinkPoolParams = message.unlinkPoolParams
                ? exports.UnlinkPoolParams.toJSON(message.unlinkPoolParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUnlinkPool);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.unlinkPoolParams =
            object.unlinkPoolParams !== undefined && object.unlinkPoolParams !== null
                ? exports.UnlinkPoolParams.fromPartial(object.unlinkPoolParams)
                : undefined;
        return message;
    },
};
const baseUnlinkPoolParams = { poolId: long_1.default.UZERO };
exports.UnlinkPoolParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUnlinkPoolParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUnlinkPoolParams);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseUnlinkPoolParams);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        return message;
    },
};
const baseMsgUnlinkPoolResponse = {};
exports.MsgUnlinkPoolResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUnlinkPoolResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUnlinkPoolResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUnlinkPoolResponse);
        return message;
    },
};
const baseMsgSetRewardsWeights = { creator: "" };
exports.MsgSetRewardsWeights = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.setRewardsWeightsParams !== undefined) {
            exports.SetRewardsWeightsParams.encode(message.setRewardsWeightsParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetRewardsWeights);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.setRewardsWeightsParams = exports.SetRewardsWeightsParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetRewardsWeights);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.setRewardsWeightsParams =
            object.setRewardsWeightsParams !== undefined &&
                object.setRewardsWeightsParams !== null
                ? exports.SetRewardsWeightsParams.fromJSON(object.setRewardsWeightsParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.setRewardsWeightsParams !== undefined &&
            (obj.setRewardsWeightsParams = message.setRewardsWeightsParams
                ? exports.SetRewardsWeightsParams.toJSON(message.setRewardsWeightsParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgSetRewardsWeights);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.setRewardsWeightsParams =
            object.setRewardsWeightsParams !== undefined &&
                object.setRewardsWeightsParams !== null
                ? exports.SetRewardsWeightsParams.fromPartial(object.setRewardsWeightsParams)
                : undefined;
        return message;
    },
};
const baseSetRewardsWeightsParams = {};
exports.SetRewardsWeightsParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.weights) {
            reward_1.RewardWeight.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetRewardsWeightsParams);
        message.weights = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.weights.push(reward_1.RewardWeight.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseSetRewardsWeightsParams);
        message.weights = ((_a = object.weights) !== null && _a !== void 0 ? _a : []).map((e) => reward_1.RewardWeight.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.weights) {
            obj.weights = message.weights.map((e) => e ? reward_1.RewardWeight.toJSON(e) : undefined);
        }
        else {
            obj.weights = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseSetRewardsWeightsParams);
        message.weights = ((_a = object.weights) !== null && _a !== void 0 ? _a : []).map((e) => reward_1.RewardWeight.fromPartial(e));
        return message;
    },
};
const baseMsgSetRewardsWeightsResponse = {};
exports.MsgSetRewardsWeightsResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetRewardsWeightsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetRewardsWeightsResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetRewardsWeightsResponse);
        return message;
    },
};
const baseMsgStakePoolToken = {
    creator: "",
    denom: "",
    amount: "",
    duration: long_1.default.UZERO,
};
exports.MsgStakePoolToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        if (!message.duration.isZero()) {
            writer.uint32(32).uint64(message.duration);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgStakePoolToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                case 4:
                    message.duration = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgStakePoolToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        message.duration =
            object.duration !== undefined && object.duration !== null
                ? long_1.default.fromString(object.duration)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        message.duration !== undefined &&
            (obj.duration = (message.duration || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgStakePoolToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "";
        message.duration =
            object.duration !== undefined && object.duration !== null
                ? long_1.default.fromValue(object.duration)
                : long_1.default.UZERO;
        return message;
    },
};
const baseMsgStakePoolTokenResponse = {};
exports.MsgStakePoolTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgStakePoolTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgStakePoolTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgStakePoolTokenResponse);
        return message;
    },
};
const baseMsgUnstakePoolToken = { creator: "", denom: "", amount: "" };
exports.MsgUnstakePoolToken = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUnstakePoolToken);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUnstakePoolToken);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgUnstakePoolToken);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgUnstakePoolTokenResponse = {};
exports.MsgUnstakePoolTokenResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUnstakePoolTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUnstakePoolTokenResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUnstakePoolTokenResponse);
        return message;
    },
};
const baseMsgClaimPoolRewards = { creator: "", poolId: long_1.default.UZERO };
exports.MsgClaimPoolRewards = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.poolId.isZero()) {
            writer.uint32(16).uint64(message.poolId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgClaimPoolRewards);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.poolId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgClaimPoolRewards);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgClaimPoolRewards);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        return message;
    },
};
const baseMsgClaimPoolRewardsResponse = {};
exports.MsgClaimPoolRewardsResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgClaimPoolRewardsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgClaimPoolRewardsResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgClaimPoolRewardsResponse);
        return message;
    },
};
const baseMsgSetRewardCurve = { creator: "" };
exports.MsgSetRewardCurve = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.setRewardCurveParams !== undefined) {
            exports.SetRewardCurveParams.encode(message.setRewardCurveParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetRewardCurve);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.setRewardCurveParams = exports.SetRewardCurveParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetRewardCurve);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.setRewardCurveParams =
            object.setRewardCurveParams !== undefined &&
                object.setRewardCurveParams !== null
                ? exports.SetRewardCurveParams.fromJSON(object.setRewardCurveParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.setRewardCurveParams !== undefined &&
            (obj.setRewardCurveParams = message.setRewardCurveParams
                ? exports.SetRewardCurveParams.toJSON(message.setRewardCurveParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgSetRewardCurve);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.setRewardCurveParams =
            object.setRewardCurveParams !== undefined &&
                object.setRewardCurveParams !== null
                ? exports.SetRewardCurveParams.fromPartial(object.setRewardCurveParams)
                : undefined;
        return message;
    },
};
const baseSetRewardCurveParams = {
    initialRewardBps: 0,
    reductionMultiplierBps: 0,
    reductionIntervalSeconds: long_1.default.UZERO,
    reductions: 0,
    finalRewardBps: 0,
};
exports.SetRewardCurveParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.startTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.startTime), writer.uint32(10).fork()).ldelim();
        }
        if (message.initialRewardBps !== 0) {
            writer.uint32(16).uint32(message.initialRewardBps);
        }
        if (message.reductionMultiplierBps !== 0) {
            writer.uint32(24).uint32(message.reductionMultiplierBps);
        }
        if (!message.reductionIntervalSeconds.isZero()) {
            writer.uint32(32).uint64(message.reductionIntervalSeconds);
        }
        if (message.reductions !== 0) {
            writer.uint32(40).uint32(message.reductions);
        }
        if (message.finalRewardBps !== 0) {
            writer.uint32(48).uint32(message.finalRewardBps);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetRewardCurveParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.startTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.initialRewardBps = reader.uint32();
                    break;
                case 3:
                    message.reductionMultiplierBps = reader.uint32();
                    break;
                case 4:
                    message.reductionIntervalSeconds = reader.uint64();
                    break;
                case 5:
                    message.reductions = reader.uint32();
                    break;
                case 6:
                    message.finalRewardBps = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSetRewardCurveParams);
        message.startTime =
            object.startTime !== undefined && object.startTime !== null
                ? fromJsonTimestamp(object.startTime)
                : undefined;
        message.initialRewardBps =
            object.initialRewardBps !== undefined && object.initialRewardBps !== null
                ? Number(object.initialRewardBps)
                : 0;
        message.reductionMultiplierBps =
            object.reductionMultiplierBps !== undefined &&
                object.reductionMultiplierBps !== null
                ? Number(object.reductionMultiplierBps)
                : 0;
        message.reductionIntervalSeconds =
            object.reductionIntervalSeconds !== undefined &&
                object.reductionIntervalSeconds !== null
                ? long_1.default.fromString(object.reductionIntervalSeconds)
                : long_1.default.UZERO;
        message.reductions =
            object.reductions !== undefined && object.reductions !== null
                ? Number(object.reductions)
                : 0;
        message.finalRewardBps =
            object.finalRewardBps !== undefined && object.finalRewardBps !== null
                ? Number(object.finalRewardBps)
                : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.startTime !== undefined &&
            (obj.startTime = message.startTime.toISOString());
        message.initialRewardBps !== undefined &&
            (obj.initialRewardBps = message.initialRewardBps);
        message.reductionMultiplierBps !== undefined &&
            (obj.reductionMultiplierBps = message.reductionMultiplierBps);
        message.reductionIntervalSeconds !== undefined &&
            (obj.reductionIntervalSeconds = (message.reductionIntervalSeconds || long_1.default.UZERO).toString());
        message.reductions !== undefined && (obj.reductions = message.reductions);
        message.finalRewardBps !== undefined &&
            (obj.finalRewardBps = message.finalRewardBps);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseSetRewardCurveParams);
        message.startTime = (_a = object.startTime) !== null && _a !== void 0 ? _a : undefined;
        message.initialRewardBps = (_b = object.initialRewardBps) !== null && _b !== void 0 ? _b : 0;
        message.reductionMultiplierBps = (_c = object.reductionMultiplierBps) !== null && _c !== void 0 ? _c : 0;
        message.reductionIntervalSeconds =
            object.reductionIntervalSeconds !== undefined &&
                object.reductionIntervalSeconds !== null
                ? long_1.default.fromValue(object.reductionIntervalSeconds)
                : long_1.default.UZERO;
        message.reductions = (_d = object.reductions) !== null && _d !== void 0 ? _d : 0;
        message.finalRewardBps = (_e = object.finalRewardBps) !== null && _e !== void 0 ? _e : 0;
        return message;
    },
};
const baseMsgSetRewardCurveResponse = {};
exports.MsgSetRewardCurveResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetRewardCurveResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetRewardCurveResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetRewardCurveResponse);
        return message;
    },
};
const baseMsgSetCommitmentCurve = { creator: "" };
exports.MsgSetCommitmentCurve = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.setCommitmentCurveParams !== undefined) {
            exports.SetCommitmentCurveParams.encode(message.setCommitmentCurveParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetCommitmentCurve);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.setCommitmentCurveParams = exports.SetCommitmentCurveParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetCommitmentCurve);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.setCommitmentCurveParams =
            object.setCommitmentCurveParams !== undefined &&
                object.setCommitmentCurveParams !== null
                ? exports.SetCommitmentCurveParams.fromJSON(object.setCommitmentCurveParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.setCommitmentCurveParams !== undefined &&
            (obj.setCommitmentCurveParams = message.setCommitmentCurveParams
                ? exports.SetCommitmentCurveParams.toJSON(message.setCommitmentCurveParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgSetCommitmentCurve);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.setCommitmentCurveParams =
            object.setCommitmentCurveParams !== undefined &&
                object.setCommitmentCurveParams !== null
                ? exports.SetCommitmentCurveParams.fromPartial(object.setCommitmentCurveParams)
                : undefined;
        return message;
    },
};
const baseSetCommitmentCurveParams = {
    maxDuration: long_1.default.UZERO,
    maxRewardMultiplier: 0,
};
exports.SetCommitmentCurveParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.maxDuration.isZero()) {
            writer.uint32(8).uint64(message.maxDuration);
        }
        if (message.maxRewardMultiplier !== 0) {
            writer.uint32(16).uint32(message.maxRewardMultiplier);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetCommitmentCurveParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.maxDuration = reader.uint64();
                    break;
                case 2:
                    message.maxRewardMultiplier = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSetCommitmentCurveParams);
        message.maxDuration =
            object.maxDuration !== undefined && object.maxDuration !== null
                ? long_1.default.fromString(object.maxDuration)
                : long_1.default.UZERO;
        message.maxRewardMultiplier =
            object.maxRewardMultiplier !== undefined &&
                object.maxRewardMultiplier !== null
                ? Number(object.maxRewardMultiplier)
                : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.maxDuration !== undefined &&
            (obj.maxDuration = (message.maxDuration || long_1.default.UZERO).toString());
        message.maxRewardMultiplier !== undefined &&
            (obj.maxRewardMultiplier = message.maxRewardMultiplier);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseSetCommitmentCurveParams);
        message.maxDuration =
            object.maxDuration !== undefined && object.maxDuration !== null
                ? long_1.default.fromValue(object.maxDuration)
                : long_1.default.UZERO;
        message.maxRewardMultiplier = (_a = object.maxRewardMultiplier) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
const baseMsgSetCommitmentCurveResponse = {};
exports.MsgSetCommitmentCurveResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetCommitmentCurveResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetCommitmentCurveResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetCommitmentCurveResponse);
        return message;
    },
};
const baseMsgUpdatePool = { creator: "" };
exports.MsgUpdatePool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.updatePoolParams !== undefined) {
            exports.UpdatePoolParams.encode(message.updatePoolParams, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdatePool);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.updatePoolParams = exports.UpdatePoolParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdatePool);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.updatePoolParams =
            object.updatePoolParams !== undefined && object.updatePoolParams !== null
                ? exports.UpdatePoolParams.fromJSON(object.updatePoolParams)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.updatePoolParams !== undefined &&
            (obj.updatePoolParams = message.updatePoolParams
                ? exports.UpdatePoolParams.toJSON(message.updatePoolParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdatePool);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.updatePoolParams =
            object.updatePoolParams !== undefined && object.updatePoolParams !== null
                ? exports.UpdatePoolParams.fromPartial(object.updatePoolParams)
                : undefined;
        return message;
    },
};
const baseUpdatePoolParams = {
    poolId: long_1.default.UZERO,
    swapFee: "",
    numQuotes: long_1.default.ZERO,
};
exports.UpdatePoolParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.swapFee !== "") {
            writer.uint32(18).string(message.swapFee);
        }
        if (!message.numQuotes.isZero()) {
            writer.uint32(24).int64(message.numQuotes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdatePoolParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.swapFee = reader.string();
                    break;
                case 3:
                    message.numQuotes = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdatePoolParams);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.swapFee =
            object.swapFee !== undefined && object.swapFee !== null
                ? String(object.swapFee)
                : "";
        message.numQuotes =
            object.numQuotes !== undefined && object.numQuotes !== null
                ? long_1.default.fromString(object.numQuotes)
                : long_1.default.ZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.swapFee !== undefined && (obj.swapFee = message.swapFee);
        message.numQuotes !== undefined &&
            (obj.numQuotes = (message.numQuotes || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseUpdatePoolParams);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.swapFee = (_a = object.swapFee) !== null && _a !== void 0 ? _a : "";
        message.numQuotes =
            object.numQuotes !== undefined && object.numQuotes !== null
                ? long_1.default.fromValue(object.numQuotes)
                : long_1.default.ZERO;
        return message;
    },
};
const baseMsgUpdatePoolResponse = {};
exports.MsgUpdatePoolResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdatePoolResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdatePoolResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdatePoolResponse);
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.HandleCreatePool = this.HandleCreatePool.bind(this);
        this.HandleCreatePoolWithLiquidity =
            this.HandleCreatePoolWithLiquidity.bind(this);
        this.HandleAddLiquidity = this.HandleAddLiquidity.bind(this);
        this.HandleRemoveLiquidity = this.HandleRemoveLiquidity.bind(this);
        this.HandleLinkPool = this.HandleLinkPool.bind(this);
        this.HandleUnlinkPool = this.HandleUnlinkPool.bind(this);
        this.HandleSetRewardsWeights = this.HandleSetRewardsWeights.bind(this);
        this.HandleStakePoolToken = this.HandleStakePoolToken.bind(this);
        this.HandleUnstakePoolToken = this.HandleUnstakePoolToken.bind(this);
        this.HandleClaimPoolRewards = this.HandleClaimPoolRewards.bind(this);
        this.HandleSetRewardCurve = this.HandleSetRewardCurve.bind(this);
        this.HandleSetCommitmentCurve = this.HandleSetCommitmentCurve.bind(this);
        this.HandleUpdatePool = this.HandleUpdatePool.bind(this);
    }
    HandleCreatePool(request) {
        const data = exports.MsgCreatePool.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Msg", "HandleCreatePool", data);
        return promise.then((data) => exports.MsgCreatePoolResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleCreatePoolWithLiquidity(request) {
        const data = exports.MsgCreatePoolWithLiquidity.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Msg", "HandleCreatePoolWithLiquidity", data);
        return promise.then((data) => exports.MsgCreatePoolWithLiquidityResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleAddLiquidity(request) {
        const data = exports.MsgAddLiquidity.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Msg", "HandleAddLiquidity", data);
        return promise.then((data) => exports.MsgAddLiquidityResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleRemoveLiquidity(request) {
        const data = exports.MsgRemoveLiquidity.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Msg", "HandleRemoveLiquidity", data);
        return promise.then((data) => exports.MsgRemoveLiquidityResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleLinkPool(request) {
        const data = exports.MsgLinkPool.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Msg", "HandleLinkPool", data);
        return promise.then((data) => exports.MsgLinkPoolResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleUnlinkPool(request) {
        const data = exports.MsgUnlinkPool.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Msg", "HandleUnlinkPool", data);
        return promise.then((data) => exports.MsgUnlinkPoolResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleSetRewardsWeights(request) {
        const data = exports.MsgSetRewardsWeights.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Msg", "HandleSetRewardsWeights", data);
        return promise.then((data) => exports.MsgSetRewardsWeightsResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleStakePoolToken(request) {
        const data = exports.MsgStakePoolToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Msg", "HandleStakePoolToken", data);
        return promise.then((data) => exports.MsgStakePoolTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleUnstakePoolToken(request) {
        const data = exports.MsgUnstakePoolToken.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Msg", "HandleUnstakePoolToken", data);
        return promise.then((data) => exports.MsgUnstakePoolTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleClaimPoolRewards(request) {
        const data = exports.MsgClaimPoolRewards.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Msg", "HandleClaimPoolRewards", data);
        return promise.then((data) => exports.MsgClaimPoolRewardsResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleSetRewardCurve(request) {
        const data = exports.MsgSetRewardCurve.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Msg", "HandleSetRewardCurve", data);
        return promise.then((data) => exports.MsgSetRewardCurveResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleSetCommitmentCurve(request) {
        const data = exports.MsgSetCommitmentCurve.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Msg", "HandleSetCommitmentCurve", data);
        return promise.then((data) => exports.MsgSetCommitmentCurveResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleUpdatePool(request) {
        const data = exports.MsgUpdatePool.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.liquiditypool.Msg", "HandleUpdatePool", data);
        return promise.then((data) => exports.MsgUpdatePoolResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
